function copy(value, context) {
  if (value == null)
    return value;
  return value.map((override) => ({ ...override, value: copyColorValue(override.value) }));
  function copyColorValue(colorValue) {
    return {
      ...colorValue,
      swatchId: context.replacementContext.swatchIds.get(colorValue.swatchId) ?? colorValue.swatchId
    };
  }
}
export {
  copy
};
//# sourceMappingURL=responsive-color.js.map